import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["items", "template"]

  connect() {
    this.index = this.itemsTarget.children.length
  }

  addItem(event) {
    event.preventDefault()
    
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
    this.itemsTarget.insertAdjacentHTML("beforeend", content)
    this.index++
  }

  removeItem(event) {
    event.preventDefault()
    
    const item = event.currentTarget.closest(".work-order-item")
    const destroyField = item.querySelector("input[name*='_destroy']")
    
    if (destroyField) {
      destroyField.value = "1"
      item.style.display = "none"
    } else {
      item.remove()
    }
  }

  removeNewItem(event) {
    event.preventDefault()
    
    const item = event.currentTarget.closest(".work-order-item")
    item.remove()
  }

  updateAssetSelect(event) {
    const assetType = event.target.value
    const assetSelect = this.element.querySelector("select[name='work_order[workable_id]']")
    
    if (!assetSelect) return
    
    if (assetType === "Vehicle") {
      this.fetchAssets("/admin/vehicles.json", assetSelect)
    } else if (assetType === "Equipment") {
      this.fetchAssets("/admin/equipment.json", assetSelect)
    } else if (assetType === "Trailer") {
      this.fetchAssets("/admin/trailers.json", assetSelect)
    } else {
      assetSelect.innerHTML = '<option value="">Select asset type first...</option>'
      assetSelect.disabled = true
    }
  }

  async fetchAssets(url, selectElement) {
    try {
      const response = await fetch(url)
      const data = await response.json()
      
      selectElement.innerHTML = '<option value="">Select...</option>'
      selectElement.disabled = false
      
      data.forEach(asset => {
        const option = document.createElement("option")
        option.value = asset.id
        option.textContent = asset.name
        selectElement.appendChild(option)
      })
    } catch (error) {
      console.error("Error fetching assets:", error)
      selectElement.innerHTML = '<option value="">Error loading assets</option>'
    }
  }
}
